import { render } from "./MessageBox.vue?vue&type=template&id=1e46d84d"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"
script.render = render

export default script